import { axios } from '@/utils/request'
const api = {
  source: '/order/AccessoryOrder',
}
//table列表数据
export function getPriceAuditlist (parameter) {
  return axios({
    url: '/basicdata/QrCode/selectList',
    method: 'get',
    params: parameter,
  })
}
//配置企业安装类别
export function selectUsableInstallType (parameter) {
  return axios({
    url: '/basicdata/QrCode/selectUsableInstallType',
    method: 'get',
    params: parameter,
  })
}